/**
 * Generated by orval v8.5.2 🍺
 * Do not edit manually.
 * Alchemer Dashboard API
 * OpenAPI spec version: 1.0.155
 */

export type LicenseLevel = (typeof LicenseLevel)[keyof typeof LicenseLevel];

export const LicenseLevel = {
  Creator: 'Creator',
  'Non-Creator': 'Non-Creator',
} as const;
